import React from 'react';
import { ContentFormatter, RichText, Columns, Column, AccordionRow, AccordionList, Stack } from '@belong/ui-components';
import { SECTION_PLAN_SUMMARY_TEST_ID as TEST_ID } from './test-ids';
import { ISectionPlanSummary } from './model';

/* Temporary component to render the footer content for the plan summary section
 ** This will be moved back into the plam summary section once the old plan cards are removed
 */

export const SectionFooter = ({ footerContent, accordionRows }) => {
  return (
    <Stack space="large">
      <Columns alignX="center">
        <Column width={{ xl: '2/3' }} data-testid={TEST_ID.footerContent}>
          <ContentFormatter alignment={{ xs: 'left', md: 'center' }} spacing="small">
            <RichText html={footerContent} />
          </ContentFormatter>
        </Column>
      </Columns>
      <Accordion accordionRows={accordionRows} />
    </Stack>
  );
};

const Accordion = React.memo(({ accordionRows }: Pick<ISectionPlanSummary, 'accordionRows'>) => {
  if (!accordionRows?.length) {
    return null;
  }

  const rows = accordionRows?.map(({ label, body, headingLevel, dictionary }) => (
    <AccordionRow key={label} label={label} headingLevel={headingLevel}>
      <RichText {...body} dictionary={dictionary} />
    </AccordionRow>
  ));

  return (
    <Columns alignX={{ xs: 'left', md: 'center' }} collapseBelow="md">
      <Column width={{ xl: '2/3' }}>
        <AccordionList items={rows} data-testid={TEST_ID.accordion} />
      </Column>
    </Columns>
  );
});
